function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  padding-top: 1rem;\n  height: 2rem;\n  display: flex;\n  justify-content: center;\n\n  .dot {\n    cursor: pointer;\n    height: 6px;\n    width: 6px;\n    margin: 0 2px;\n    background-color: #c4c4c4;\n    border-radius: 50%;\n    display: inline-block;\n    transition: background-color 0.6s ease;\n\n    &.selected {\n      background: ", ";\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  min-height: ", ";\n  transition: background-color 0.6s ease;\n  .component {\n    margin: 5px;\n    -webkit-animation-name: fade;\n    -webkit-animation-duration: 1.5s;\n    animation-name: fade;\n    animation-duration: 1.5s;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  .hide {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
var StyledCarousel = styled.div(_templateObject());
var StyledComponentList = styled.div(_templateObject2(), function (_ref) {
  var height = _ref.height;
  return "" + height;
});
var NavigationControl = styled.div(_templateObject3(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.textColor;
});

var Carousel = function Carousel(_ref3) {
  var components = _ref3.components,
      variant = _ref3.variant,
      height = _ref3.height,
      customClass = _ref3.customClass,
      rest = _objectWithoutPropertiesLoose(_ref3, ["components", "variant", "height", "customClass"]);

  var touchVariation = 0;
  var SWIPE_THRESHOLD = 50;

  var _useState = useState({
    currentCardIndex: 0
  }),
      carouselState = _useState[0],
      setCarouselState = _useState[1];

  var handleNavDotClick = function handleNavDotClick(event, index) {
    setCarouselState({
      currentCardIndex: Number(index)
    });
  };

  var handleTouchStart = function handleTouchStart(event) {
    touchVariation = 0;
    touchVariation = event.changedTouches[0].pageX;
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    var tempCounter = carouselState.currentCardIndex;
    touchVariation = touchVariation - event.changedTouches[0].pageX;

    if (touchVariation < -SWIPE_THRESHOLD || touchVariation > SWIPE_THRESHOLD) {
      setCarouselState({
        currentCardIndex: touchVariation > 0 ? increment(tempCounter) : decrement(tempCounter)
      });
    }
  };

  var increment = function increment(tempCounter) {
    return tempCounter < (components && components.length - 1) ? tempCounter + 1 : 0;
  };

  var decrement = function decrement(tempCounter) {
    return tempCounter > 0 ? tempCounter - 1 : components && components.length - 1;
  };
  /* TODO: timer feature will be picked up later */
  //   useEffect(() => {
  //   setInterval(() => {
  //     console.log('timer');
  //     let tempCounter = carouselState.currentCardIndex;
  //     setCarouselState({
  //       currentCardIndex: tempCounter < (components && components.length - 1) ? tempCounter + 1 : 0,
  //     });
  //     //   Number(increamentCounter(components && components.length - 1))
  //   }, 3000);
  //   }, []);


  return /*#__PURE__*/React.createElement(StyledCarousel, _extends({
    className: variant + " " + customClass
  }, rest), /*#__PURE__*/React.createElement(StyledComponentList, {
    className: variant,
    height: height,
    onTouchStart: handleTouchStart,
    onTouchEnd: handleTouchEnd
  }, carouselState && components.map(function (_ref4, index) {
    var Component = _ref4.component,
        styledClass = _ref4.styledClass,
        propsData = _ref4.propsData;
    return /*#__PURE__*/React.createElement(Component, _extends({
      className: "component " + (styledClass || '') + " " + (carouselState.currentCardIndex !== index ? 'hide' : ''),
      key: index
    }, propsData));
  })), /*#__PURE__*/React.createElement(NavigationControl, rest, components && components.length && components.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "dot " + (index === carouselState.currentCardIndex ? 'selected' : ''),
      onClick: function onClick(event) {
        return handleNavDotClick(event, index);
      }
    });
  })));
};

Carousel.propTypes = process.env.NODE_ENV !== "production" ? {
  components: PropTypes.arrayOf(PropTypes.shape({
    component: PropTypes.func.isRequired,
    propsData: PropTypes.object.isRequired,
    styledClass: PropTypes.string
  })),
  variant: PropTypes.string,
  height: PropTypes.string,
  customClass: PropTypes.string
} : {};
Carousel.defaultProps = {
  variant: 'default',
  height: '10rem',
  customClass: '',
  theme: defaultTheme
};
export default Carousel;